import { render, staticRenderFns } from "./share-health-vault-recipient-auth.vue?vue&type=template&id=46e6ccf1&scoped=true&"
import script from "./share-health-vault-recipient-auth.vue?vue&type=script&lang=js&"
export * from "./share-health-vault-recipient-auth.vue?vue&type=script&lang=js&"
import style0 from "./share-health-vault-recipient-auth.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./share-health-vault-recipient-auth.vue?vue&type=style&index=1&id=46e6ccf1&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "46e6ccf1",
  null
  
)

export default component.exports